import { EventsOfTask } from 'pages/Tasks/types'
import type { Action } from 'redesign/components/organisms/action-wrapper/types'
import { TASK_STATES } from '../../ContentLists/TaskList/constants'
import deleteWorkflowButton from '../../task-details-action-buttons/buttons/delete-workflow-button'
import type { ResolveActionButtonsProps } from '../../task-details-action-buttons/types'
import { getCommentButton } from '../../task-details-action-buttons/utils/get-comment-button'
import { getReminderButton } from '../../task-details-action-buttons/utils/get-reminder-button'

export const getOfficeActionButtons = (props: ResolveActionButtonsProps): Action[] => {
  const { task, canSendReminder, canSendComment } = props
  const { statusFe } = task

  if (statusFe === TASK_STATES.closed) return []

  return [
    ...(canSendReminder ? [getReminderButton({ ...props })] : []),
    ...(canSendComment
      ? [getCommentButton({ ...props, taskEvent: EventsOfTask.secureConnectionSendCommentToFrontline })]
      : []),
    ...[deleteWorkflowButton(props)],
  ]
}
